import { render, staticRenderFns } from "./AskAQuestionPrompt.vue?vue&type=template&id=ce7d9c20&scoped=true"
import script from "./AskAQuestionPrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./AskAQuestionPrompt.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AskAQuestionPrompt.vue?vue&type=style&index=0&id=ce7d9c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7d9c20",
  null
  
)

export default component.exports